export default "__VITE_ASSET__CAYjPPg9__"